import { render, staticRenderFns } from "./kayton-aloitus.vue?vue&type=template&id=1f962324&scoped=true&"
import script from "./kayton-aloitus.vue?vue&type=script&lang=ts&"
export * from "./kayton-aloitus.vue?vue&type=script&lang=ts&"
import style0 from "./kayton-aloitus.vue?vue&type=style&index=0&id=1f962324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f962324",
  null
  
)

export default component.exports